import React from 'react';
import {makeStyles} from "@mui/styles";
import {useNavigate} from "react-router-dom";
import {initFormHandler} from "../../../../Handler/FormHandler";
import ShadowBoxComponent from "../../../../Component/ShadowBoxComponent";
import TitleComponent from "../../../../Component/TitleComponent";
import TextFieldComponent from "../../../../Component/TextFieldComponent";
import ButtonComponent from "../../../../Component/ButtonComponent";
import ApiHandler from "../../../../Handler/ApiHandler";
import {getRoutePathname} from "../../../../Handler/RouteHandler";
import {SnackbarOpen} from "../../../../Action/SnackbarAction";
import {useDispatch, useSelector} from "react-redux";
import {LinearProgressMainLayoutActivate, LinearProgressMainLayoutDeactivate} from "../../../../Action/LinearProgressMainLayoutAction";
import {hasRight} from "../../../../Common/UserCommon";
import { Grid } from '@mui/material';

function ShopCashRegisterForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authenticationReducer = useSelector(state => state.AuthenticationReducer);
    const [totalOpening, setTotalOpening] = React.useState(null);
    const justWatch = !hasRight(authenticationReducer, 'ROLE_SHOP_SHOP_SALES') && !hasRight(authenticationReducer, 'ROLE_SHOP_SELLER');

    const [form, setForm] = React.useState({
        b500: {
            name: 'b500',
            label: '500€',
            textHelper: 'Saisissez le nombre de billet de 500 euros.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        b200: {
            name: 'b200',
            label: '200€',
            textHelper: 'Saisissez le nombre de billet de 200 euros.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        b100: {
            name: 'b100',
            label: '100€',
            textHelper: 'Saisissez le nombre de billet de 100 euros.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        b50: {
            name: 'b50',
            label: '50€',
            textHelper: 'Saisissez le nombre de billet de 50 euros.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        b20: {
            name: 'b20',
            label: '20€',
            textHelper: 'Saisissez le nombre de billet de 20 euros.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        b10: {
            name: 'b10',
            label: '10€',
            textHelper: 'Saisissez le nombre de billet de 10 euros.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        b5: {
            name: 'b5',
            label: '5€',
            textHelper: 'Saisissez le nombre de billet de 5 euros.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        p2: {
            name: 'p2',
            label: '2€',
            textHelper: 'Saisissez le nombre de pièces de 2 euros.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        p1: {
            name: 'p1',
            label: '1€',
            textHelper: 'Saisissez le nombre de pièces de 1 euro.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        p050: {
            name: 'p050',
            label: '0.5€',
            textHelper: 'Saisissez le nombre de pièces de 50 cents.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        p020: {
            name: 'p020',
            label: '0.2€',
            textHelper: 'Saisissez le nombre de pièces de 20 cents.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        p010: {
            name: 'p010',
            label: '0.1€',
            textHelper: 'Saisissez le nombre de pièces de 10 cents.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        p005: {
            name: 'p005',
            label: '0.05€',
            textHelper: 'Saisissez le nombre de pièces de 5 cents.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        p002: {
            name: 'p002',
            label: '0.02€',
            textHelper: 'Saisissez le nombre de pièces de 2 cents.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        p001: {
            name: 'p001',
            label: '0.01€',
            textHelper: 'Saisissez le nombre de pièces de 1 cents.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
    });
    const [isLoadingForm, setIsLoadingForm] = React.useState(false);
    const handlerForm = initFormHandler(form, setForm);
    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            setIsLoadingForm(true);
            dispatch(LinearProgressMainLayoutActivate());

            if (props.shopId) {
                ApiHandler.post({
                    route: 'api_shop_sales_open',
                    data: handlerForm.getData(),
                    params: {id: props.shopId}
                }, (response) => {
                    if (response.status === 200) {
                        dispatch(
                            SnackbarOpen({
                                text: 'Caisse ouverte avec succès.',
                                variant: 'success',
                            })
                        );

                        navigate(getRoutePathname('shop_sales_sign_opening'));

                    } else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    } else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }
                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
        }
    };

    const calculateTotalCash = (value) => {
        var b500 = document.getElementById("b500").value;
        var b200 = document.getElementById("b200").value;
        var b100 = document.getElementById("b100").value;
        var b50 = document.getElementById("b50").value;
        var b20 = document.getElementById("b20").value;
        var b10 = document.getElementById("b10").value;
        var b5 = document.getElementById("b5").value;

        var p2 = document.getElementById("p2").value;
        var p1 = document.getElementById("p1").value;
        var p050 = document.getElementById("p050").value;
        var p020 = document.getElementById("p020").value;
        var p010 = document.getElementById("p010").value;
        var p005 = document.getElementById("p005").value;
        var p002 = document.getElementById("p002").value;
        var p001 = document.getElementById("p001").value;

        var total = parseFloat(b500 * 500) + parseFloat(b200 * 200) + parseFloat(b100*100) + parseFloat(b50*50) + parseFloat(b20*20) + parseFloat(b10*10) + parseFloat(b5*5) + parseFloat(p2*2) + parseFloat(p1*1) + parseFloat(p050*0.5) + parseFloat(p020*0.2) + parseFloat(p010*0.1) + parseFloat(p005*0.05) + parseFloat(p002*0.02) + parseFloat(p001*0.01);

        setTotalOpening(total.toFixed(2));
    };

    React.useEffect(handlerForm.start, []);
    React.useEffect(() => {
        if (props.shop) {
            handlerForm.setDataApi(props.shop);
        }
    }, []);
    React.useEffect(() => {
        handlerForm.setFormLoading(justWatch);
    }, [justWatch]);

    return (
        <ShadowBoxComponent className={classes.shadowBox}>
            <TitleComponent title={'Ouverture fonds de caisse'}/>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'b500'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'b200'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'b100'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'b50'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'b20'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'b10'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'b5'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'p2'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'p1'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'p050'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'p020'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'p010'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'p005'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'p002'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'p001'} handler={handlerForm} onBlur={(val) => calculateTotalCash(val)}/>
                </Grid>
            </Grid>
            <hr/>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                    <h4>Total ouverture caisse : {totalOpening} €</h4>
                </Grid>
            </Grid>

            {!justWatch && <ButtonComponent label={'Enregistrer'} className={classes.button} onClick={save} loading={isLoadingForm}/>}
        </ShadowBoxComponent>
    );
}

const useStyles = makeStyles({
    shadowBox: {
        paddingBottom: 45,
        height: '100%'
    },
    button: {
        margin: '15px !important',
        bottom: '0 !important',
        right: '0 !important',
        position: 'absolute !important'
    },
    owner: {
        backgroundColor: '#9c27b0',
        color: '#FFF',
        borderRadius: 25,
        padding: '5px 10px',
        marginLeft: 10,
        fontSize: 11,
        position: 'absolute',
        top: 7,
        right: 14
    }
});

export default ShopCashRegisterForm;
